/** Product strength is separate from the amount taken, such as "1 tablet". */
export function resolveCatalogStrength(input: {
    catalogStrength?: string | null;
    enteredStrength: string;
    notApplicable: boolean;
    isSupplement: boolean;
}): { strength: string | undefined; needsEntry: boolean; ready: boolean } {
    const rawCatalogStrength = input.catalogStrength?.trim();
    // Historical reference rows sometimes contain directions or missing-value
    // markers in this column. A nonempty string alone is not evidence of a
    // product strength. Ask the nurse rather than treating it as confirmed.
    // This only checks catalog defaults; a nurse can still enter label text or
    // explicitly confirm that strength does not apply.
    const catalogStrength =
        rawCatalogStrength &&
        /\d/.test(rawCatalogStrength) &&
        !/unspecified|not specified|not marked|not sure|no units|unreadable|unknown|missing/i.test(
            rawCatalogStrength
        )
            ? rawCatalogStrength
            : undefined;
    if (catalogStrength) {
        return { strength: catalogStrength, needsEntry: false, ready: true };
    }
    const needsEntry = true;
    const strength = input.notApplicable ? undefined : input.enteredStrength.trim() || undefined;
    return { strength, needsEntry, ready: !needsEntry || Boolean(strength) || input.notApplicable };
}
